import React from 'react';
import { useSelector } from 'react-redux';
import Authentication from '../commons/auth/Authentication';
import Incidents from '../components/incidents';
import { CustomReducerState } from '../redux/reducers';
import { incidentsNameRoute } from './paths';

const IncidentsPage = () => {
    const userConnected = useSelector((state: CustomReducerState) => state.ticketing.user.userConnected);
    return <Authentication redirectTo={incidentsNameRoute}>{userConnected && <Incidents />}</Authentication>;
};

export default IncidentsPage;
